<template>
  <div>
    <LoginDialog></LoginDialog>
    <RegisterDialog></RegisterDialog>
    <ForgetPwdDialog></ForgetPwdDialog>
  </div>
</template>

<script>
import LoginDialog from '../pages/passport/LoginDialog'
import RegisterDialog from '../pages/passport/RegisterDialog'
import ForgetPwdDialog from '../pages/passport/ForgetPwdDialog'

export default {
  name: 'GlobalDialogs',
  components: {
    LoginDialog: LoginDialog,
    RegisterDialog: RegisterDialog,
    ForgetPwdDialog: ForgetPwdDialog
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/GlobalDialogs.vue